import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  selectAvailableLanguages,
  selectLanguage,
} from '@epicuro-next/platform/i18n';
import { setLanguagePrefrence } from '@epicuro-next/state/user-state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'epc-language-selector',
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguageSelectorComponent {
  public availableLanguages$ = this.store.select(selectAvailableLanguages);
  public selectedLanguage$ = this.store.select(selectLanguage);

  constructor(private store: Store) {}

  public setLanguage(id: string) {
    this.store.dispatch(setLanguagePrefrence({ languageCode: id }));
  }
}
